<template>
  <div class="appoint">
    <top-nav :list="topList"></top-nav>
    <!--<above-nav></above-nav>-->
    <div class="content-wrapper">
      <div class="content">
        <p class="attention">注意：学生在申请预约后，请老师或网校管理员及时与学生取得联系，并开设相应的班级供其报名学习。</p>
        <p class="more">
          所有学生均可预约1对1或1对多模式的班级，预约时间和上课周期等，每位用户一个课程只能预约一次。
        </p>
        <table class="table">
          <tr class="first">
            <th style="width: 230px;">用户</th>
            <th style="width: 180px;">预约班级</th>
            <th style="width: 256px;">预约上课时间</th>
            <th style="width: 180px;">预约周期</th>
            <th style="width: 220px;">留言</th>
          </tr>
          <tr v-for="(item,index) in appointList" class="tr">
            <td style="text-align: left">
              <p class="name">用户id： {{item.userid}}</p>
              <p class="enrolltime">申请时间： {{decodeURIComponent(item.addtime.substring(0, 16))}}</p>
              <p class="contact" @click="showUser(item.userid)">联系学生</p>
            </td>
            <td style="font-size:16px;color:#000;vertical-align: middle;font-weight:bold">
              {{decodeURIComponent(item.classmodename)}}
            </td>
            <td style="font-size:14px;color:#000;vertical-align: middle;font-weight:bold">
              {{item.starttime.substring(0, 10)}}
              {{item.starttime.substring(11, 16)}}-{{item.endtime.substring(11, 16)}}
            </td>
            <td style="font-size:14px;color:#000;vertical-align: middle;font-weight:bold">
              {{decodeURIComponent(item.classperiodname)}}
            </td>
            <td style="vertical-align: middle;">
              {{decodeURIComponent(item.note)}}
            </td>
          </tr>
        </table>
        <template v-if="!isEmpty(appointList)">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page.sync="currentPage"
            :page-size="10"
            @current-change="handleCurrentChange"
            :total="totoalPage">
          </el-pagination>
        </template>
      </div>
    </div>
    <div class="userinfoPop" v-show="bShow">
      <div class="dialog-wrapper">
        <p class="title">联系学生</p>
        <div class="userinfo">
          <p class="phone">手机号：{{userinfo.phone}}</p>
          <p class="wx" v-if="userinfo.wx">微信号：{{decodeURIComponent(userinfo.wx)}}</p>
        </div>
        <button class="close" @click="bShow=false">关闭</button>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import topNav from 'components/topnav/TopNav';
  import aboveNav from 'components/abovenav/AboveNav'
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        lessoninfo: (() => loadLocal('lessoninfo', false))(),
        imgprefix: (() => loadLocal('imgprefix', false))(),
        topList: [
          {
            name: '班级管理',
            to: '/console/lesson/class',

          },
          {
            name: '课件管理',
            to: '/console/lesson/ware',
          },
          {
            name: '课程表',
            to: '/console/lesson/schedule',
          },
          {
            name:'课程优惠券',
            to:'/console/lesson/coupon'
          },
          {
            name: '班级预约',
            to: '/console/lesson/appoint',
          },
          {
            name: '课程评价',
            to: '/console/lesson/rate',
          },
        ],
        currentPage: 1,
        appointList: [],
        totoalPage: 0,
        bShow: false,
        userinfo: {},
      }
    },
    methods: {
      isEmpty(obj){
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      //当页面改变时
      handleCurrentChange(val) {
        this.appointList = [];
        this.loadEnrollUsers(val);
        this.$forceUpdate();
      },
      //获取对应于课程的预约列表
      loadEnrollUsers(page){
        //接口：查询预约申请数据列表
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'EnrollUser',
            a: 'QueryLessonEnrollUsers',
            id: this.id,
            rid: this.schoolNow.rid,
            lessonid: this.lessoninfo.id,
            pageno: page,
            pagesize: 10,
            count: 1,
          }
        }).then((response) => {
          response = response.data;
          if(response.code===111){
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code == 200) {
            this.appointList = response.list;
            this.totoalPage = response.recordcount;
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      showUser(userid){
        this.searchUserinfo(userid);
      },
      //查询学生的资料
      searchUserinfo(userid){
        //接口：查询用户资料
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'user',
            a: 'userinfo',
            id: this.id,
            userid: userid,
          }
        }).then((response) => {
          response = response.data;
          if(response.code===111){
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code == 200) {
            this.userinfo.wx = response.wx;
            this.userinfo.phone = response.phone;
            this.bShow = true;
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      }

    },
    created(){
      this.loadEnrollUsers(1);
    },
    components: {
      topNav,
      aboveNav
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .appoint
    position absolute
    left: 160px
    top: 0
    right: 0
    bottom: 0
    background #f2f2f2
    overflow auto
    z-index:10
    .content-wrapper
      position fixed
      left: 160px
      top: 51px
      right: 0
      bottom: 0
      padding: 20px 0 20px
      min-width: 1206px
      font-size: 0
      overflow auto
      .content
        margin: 0 auto
        width: 1166px
        padding: 50px 0 20px 50px
        background #fff
        .attention
          font-size: 16px
          color: #000000
          line-height: 22px
          font-weight: bold
        .more
          margin: 20px 0 50px 45px
          font-size: 14px
          color: #666
          line-height: 20px
        .table
          width: 1066px
          border: 1px solid #d7d7d7
          table-layout: fixed
          .first
            height: 40px
            th
              font-size: 14px
              color: #888
              line-height: 40px
              border: 1px solid #d7d7d7
              box-sizing: border-box

          .tr
            height: 120px
            text-align: center
            border: 1px solid #d7d7d7
            td
              border: 1px solid #d7d7d7
              font-size: 14px
              color: #888
              overflow hidden
              .name
                margin: 24px 0 10px 30px
                font-size: 12px
                color: #888888
                line-height: 16px
              .enrolltime
                margin: 0 0 10px 30px
                font-size: 12px
                color: #888888
                line-height: 18px
              .contact
                margin: 0 0 10px 30px
                font-size: 14px
                color: #3399ff
                cursor pointer
                line-height: 18px
                &:hover
                  text-decoration underline
    .userinfoPop
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      .dialog-wrapper
        margin: auto
        padding: 30px 0 30px 60px
        width: 380px
        border-radius: 4px
        background: #ffffff
        box-sizing border-box
        .title
          font-size: 24px
          color: #000000
          font-weight: bold
          line-height: 32px
        .userinfo
          padding: 50px 0 0 30px
          .phone
            font-size: 16px
            color: #000000
            line-height: 24px
            margin-bottom: 18px
          .wx
            font-size: 16px
            color: #000000
            line-height: 24px
        .close
          display: inline-block
          margin: 40px 0 0 80px
          width: 100px
          height: 40px
          line-height: 40px
          font-size: 16px
          color: #ffffff
          text-align: center
          border-radius 4px
          background #3399ff

</style>



// WEBPACK FOOTER //
// src/page/lesson/appoint/Appoint.vue